import { render } from "./StickFooter.vue?vue&type=template&id=68503662&scoped=true"
const script = {}

import "./StickFooter.vue?vue&type=style&index=0&id=68503662&scoped=true&lang=css"

import exportComponent from "/Users/voltz/Documents/Github/Website/CraftMasters/mobile/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68503662"]])

export default __exports__